const path = require('path')
// import loginApi from "./modules/loginApi";
const reqs = require.context("@/api/modules", false, /\.js$/)
const modules = {}
reqs.keys().forEach(key => {
    const name = path.basename(key, '.js')
    modules[name] = reqs(key).default || reqs(key)
  })
// console.log(reqs,'reqs');
console.log(modules,'modules');
const API = modules
  export default API;